import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { TransactionTypeFilter } from '@features/bankTransactions/enums/transactionTypeFilter'

import { SearchWithFilters } from '../../../../../../SearchWithFilters'
import { LinkableTransactionsFilters } from '../../TransactionsList'
import { TransactionsListFiltersPanel } from './elements/TransactionsListFilterPanel'

interface TransactionsListSearchProps {
  filters: LinkableTransactionsFilters
  currency?: string
  onSearchChange: (searchQuery?: string) => void
  onAmountRangeChange?: (minAmount?: number, maxAmount?: number) => void
  onTransactionSideChange?: (transactionSideFilter?: TransactionTypeFilter) => void
  resetFilters: () => void
}

export const TransactionsListSearch = ({
  filters,
  currency,
  onSearchChange,
  onAmountRangeChange,
  onTransactionSideChange,
  resetFilters,
}: TransactionsListSearchProps): ReactElement => {
  const { t } = useTranslation()

  const handleSearchChange = useCallback(
    (value: string | undefined) => {
      onSearchChange(value)
    },
    [onSearchChange],
  )

  return (
    <SearchWithFilters
      searchQuery={filters.searchQuery}
      onSearchChange={handleSearchChange}
      searchPlaceholder={t('bank_transactions.drawer.transactions_search_placeholder')}
      filtersPanel={
        <TransactionsListFiltersPanel
          filters={filters}
          onAmountRangeChange={onAmountRangeChange}
          onTransactionSideChange={onTransactionSideChange}
          currency={currency}
          resetFilters={resetFilters}
        />
      }
    />
  )
}
